import { environment } from "@nx-superprep/environment"

export function isDevelopment() { return !environment.config.isProduction }
export function isProduction() { return !isDevelopment() }

